import { createContext, useState } from 'react';

// export const DrawContext = createContext({});
export const MapContext = createContext({});

export const MapContextProvider = ({ children }) => {
  const [map, setMap] = useState(null);
  const [draw, setDraw] = useState(null);

  return (
    <MapContext.Provider value={{ map, setMap, draw, setDraw }}>
      {children}
    </MapContext.Provider>
  );
};
